import { ApolloError } from '@parkchirp/api-client';
import React, { FC } from 'react';

interface DisclaimerProps {
	creditCardFee: string;
	creditCardFeeLoading: boolean;
	creditCardFeeError?: ApolloError;
}

export const CreditCardFeeDisclaimer: FC<DisclaimerProps> = ({
	creditCardFee,
	creditCardFeeLoading,
	creditCardFeeError,
}) => (
	<>
		{creditCardFeeError ? (
			<p style={{ fontWeight: 'bold', fontSize: '12px' }}>Error calculating credit card fee</p>
		) : creditCardFeeLoading ? (
			<p style={{ fontWeight: 'bold', fontSize: '12px' }}>Calculating credit card fee...</p>
		) : creditCardFee ? (
			<p style={{ fontWeight: 'bold', fontSize: '12px' }}>
				A credit card fee of ${creditCardFee} will be applied across the invoice(s)
			</p>
		) : null}
	</>
);
